var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "h-100 searchable-list-with-file",
      attrs: { id: "searchable-list-with-file-" + _vm.element.id }
    },
    [
      _c("div", { staticClass: "row m-0 h-100" }, [
        _vm.element.data.name || _vm.element.data.content
          ? _c(
              "div",
              { staticClass: "text col-12 col-md-9" },
              [
                _vm.element.data.name
                  ? _c("block-headline", {
                      staticClass: "text__headline mb-0",
                      attrs: { text: _vm.element.data.name }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.element.data.content
                  ? _c("div", {
                      staticClass: "text__content",
                      domProps: { innerHTML: _vm._s(_vm.element.data.content) }
                    })
                  : _vm._e()
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.element.data.file
          ? _c("div", { staticClass: "link col-12 col-md-3" }, [
              _c(
                "a",
                {
                  staticClass: "link__element",
                  attrs: {
                    href: "/storage" + _vm.element.data.file,
                    title: "Download" + _vm.element.data.name,
                    target: "_blank"
                  }
                },
                [
                  _vm._v("Datei herunterladen "),
                  _c("i", { staticClass: "fad fa-download" })
                ]
              )
            ])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }